import { createElement } from 'react';
import {
  MentionEntityMenuIcon,
  type ChatMentionsMenuItemType,
} from '@terra/ui-design-system';
import { normalizeHttpHeaders } from '@terra/shared-utils';
import type { HttpMentionData } from '@terra/shared-dto-chat-types';
import type { HttpRequest } from '../store/proxy-store';
import { formatHttpRequestRaw } from './formatHttpForPanel';

export function httpRequestToMentionMenuItem(
  request: HttpRequest,
  source: 'global' | 'replay',
): ChatMentionsMenuItemType | null {
  let displayPath = request.url;

  try {
    const parsed = new URL(request.url);

    displayPath = parsed.pathname + parsed.search;
    if (displayPath.length > 40) {
      displayPath = displayPath.slice(0, 37) + '...';
    }
  } catch {
    if (displayPath.length > 40) {
      displayPath = displayPath.slice(0, 37) + '...';
    }
  }

  const label = `${request.method} ${displayPath}`;

  const normalizedHeaders: Record<string, string> = Object.fromEntries(
    Object.entries(normalizeHttpHeaders(request.headers)).map(
      ([key, value]) => [key, Array.isArray(value) ? value.join(', ') : value],
    ),
  );

  let rawText: string;

  try {
    rawText = formatHttpRequestRaw({
      method: request.method,
      url: request.url,
      headers: normalizedHeaders,
      body: request.body,
      httpVersion: request.httpVersion,
    });
  } catch {
    return null;
  }

  const httpData: HttpMentionData = {
    method: request.method,
    url: request.url,
    headers: normalizedHeaders,
    body: request.body,
    contentType:
      normalizedHeaders['content-type'] || normalizedHeaders['Content-Type'],
    rawText,
  };

  return {
    id: `httpRequest-${source}-${request.id}`,
    label,
    icon: createElement(MentionEntityMenuIcon, { entityType: 'HttpRequest' }),
    type: 'child',
    mentionEntity: {
      entityType: 'HttpRequest',
      entityId: request.id,
      label,
      extraData: { httpRequest: httpData },
    },
  };
}
